import About from "./About";
import Home from "./Home";
import Projects from "./Projects";
import Skills from "./Skills";
import Links from "./Links";

const Body = () => {
    return (
        <>
            <Home/>
            <About/>
            <Skills/>
            <Projects/>
            <Links/>
        </>
    );
}
 
export default Body;